import React from 'react';

function WorkloadSelectionStep({ state, setState, serviceData, setCurrentStep }) {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Select Workload Type</h2>
        <p className="text-gray-600 mb-6">
          Choose the workload type that best matches your requirements. Pricing will be calculated in the final step.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {Object.entries(serviceData.instanceTypes).map(([key, value]) => {
          const isSelected = state.workload === key;

          return (
            <button
              key={key}
              onClick={() => {
                setState(prev => ({ ...prev, workload: key }));
                setCurrentStep(4);
              }}
              className={`
                p-6 rounded-lg border transition-all duration-200 text-left
                ${isSelected
                  ? 'border-blue-500 bg-blue-50 shadow-md'
                  : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50'
                }
              `}
            >
              <h3 className="font-medium text-lg text-gray-900">{value.name}</h3>

              {/* Display instance type */}
              <div className="mt-2 text-xl font-bold text-blue-600">
                {value.instance}
              </div>

              <div className="mt-2 text-sm text-gray-500">
                Includes {value.storage}GB Storage
              </div>

              {/* Display use-case description */}
              <div className="mt-2 text-sm text-gray-500">
                {value.useCase}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default WorkloadSelectionStep;